<template>
  <el-dialog
    v-dialog-drag
    :visible.sync="innerVisible"
    :title="`${$t('CargoMsg.Cargo_Air')}${$t('Message.FreightRateDetails')}`"
    width="1000px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="air-price-dialog"
  >
    <template v-if="innerVisible">
      <div class="price-dialog-header">
        <div class="left">
          <h2>
            <span>{{ getPortName(price.pol) }}</span>
            <span style="margin:0 10px">————</span>
            <span>{{ getPortName(price.pod) }}</span>
          </h2>
          <h3>
            {{ $t('Price.FreightNumber') }}
            <span>{{ price.priceNo }}</span>
          </h3>
        </div>
        <div class="right green">
          <div style="flex: 1;margin-right: 10px">
            <el-row type="flex" justify="end">
              <el-col :span="5">+45</el-col>
              <el-col :span="5">+100</el-col>
              <el-col :span="5">+300</el-col>
              <el-col :span="5">+500</el-col>
              <el-col :span="5">+1000</el-col>
            </el-row>
            <el-row type="flex" justify="end">
              <el-col :span="5">{{ ColumnUtils.airPriceLabel(price.p45) }}</el-col>
              <el-col :span="5">{{ ColumnUtils.airPriceLabel(price.p100) }}</el-col>
              <el-col :span="5">{{ ColumnUtils.airPriceLabel(price.p300) }}</el-col>
              <el-col :span="5">{{ ColumnUtils.airPriceLabel(price.p500) }}</el-col>
              <el-col :span="5">{{ ColumnUtils.airPriceLabel(price.p1000) }}</el-col>
            </el-row>
          </div>
        </div>
      </div>
      <div class="price-dialog-content">
        <div class="description">
          <template>
            <div>
              <el-row>
                <el-col :span="1">{{ $t('Pricing.Carrier_Air') }}</el-col>
                <el-col :span="4" class="blue">{{ ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', price.carrier, 'shortName') }}</el-col>
              </el-row>
              <el-row>
                <el-col :span="2">{{ $t('Pricing.BookingAgent') }}</el-col>
                <el-col :span="21" class="blue">{{ getBookingAgentName(price.bookingAgent) }}</el-col>
              </el-row>
            </div>
          </template>
          <template>
            <div>
              <div class="info">
                <span>{{ $t('Pricing.Days') }}</span>
                <span class="blue">{{ price.days }}</span>
                <span>{{ $t('Pricing.DepartureDay') }}</span>
                <span class="blue">{{ isFrequency }}</span>
                <span>{{ $t('Pricing.Via') }}</span>
                <span class="blue">{{ getPortName(price.via) }}</span>
                <span>{{ $t('Pricing.BeginDate') }}</span>
                <span class="blue">{{ `${$moment(price.beginDate).format('YYYY-MM-DD')}  -  ${$moment(price.endDate).format('YYYY-MM-DD')}` }}</span>
              </div>
              <div class="info">
                <span style="float: left;">{{ $t('Pricing.Remarks') }}</span>
                <textarea no="remarks" :value="price.remarks" class="blue" style="width:90%;border: none; overflow-y: visible; resize: none;" readonly />
              </div>
              <div class="info">
                <span>{{ $t('Pricing.priceNature') }}</span>
                <span class="blue">{{ ColumnUtils.showTypeLabelFunc(price.priceNature, PriceConstant.PRICE_NATURE) }}</span>
              </div>
            </div>
          </template>
        </div>
        <template>
          <fright-sur-charge-grid
            config-module="202506171"
            :show-approve="false"
            :show-selection="false"
            :show-basic-info="false"
            :show-cost-or-sell="true"
            :row-data="frightSurChargeData"
            :grid-options="frightSurChargeDataGrid.gridOptions"
          />
        </template>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import * as PriceConstant from '@/class/cargo/model/parameters/PriceConstant'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import { getObjectByCache, resolveSpecificField2Value } from '@/utils/basicDataCache'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import StrUtils from '@/utils/StrUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { TenantUtil } from '@/class/cargo/model/utils/TenantUtil'
import FrightSurChargeGrid from '@/views/cargo/v0/Price/components/grid/FrightSurChargeGrid'
import { querySurchargeAirsByScore } from '@/api/price/priceAir'

export default {
  name: 'PriceDialog',
  components: {
    FrightSurChargeGrid, CargoAgGrid
  },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    price: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      PriceUtils, PriceConstant, ColumnUtils, TYPE_NAMES,
      frightSurChargeData: [],
      frightSurChargeDataGrid: {
        gridOptions: {}
      }
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    isFrequency() {
      const FREQUENCYS = PriceUtils.FREQUENCYS
      const arr = []
      for (const field of FREQUENCYS) {
        if (this.price['frequency' + field]) {
          arr.push(field)
        }
      }
      return arr.join('/')
    },
    isZh() {
      return this.$store.getters.language
    }
  },
  watch: {
    price() {
      this.getSurchargeAirsData()
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.tenantUtil = await TenantUtil.getInstance()
      this.getSurchargeAirsData()
    },

    getSurchargeAirsData() {
      const region = resolveSpecificField2Value(TYPE_NAMES.basic_data_Airport, 'code', this.price.pod, 'region')
      const payload = {
        bookingAgent: this.price.bookingAgent,
        carrier: this.price.carrier,
        pol: this.price.pol,
        pod: this.price.pod,
        region,
        beginDate: this.price.beginDate,
        endDate: this.price.endDate
      }
      querySurchargeAirsByScore(payload).then(res => {
        this.frightSurChargeData = res.data
      })
    },
    getPortName(code) {
      const port = getObjectByCache(TYPE_NAMES.basic_data_Airport, 'code', code)
      return port ? port.englishName : code
    },
    getCompanyByIdSync(cmpIdx) {
      if (!cmpIdx || cmpIdx <= 0) return null
      const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', cmpIdx)
      return company || null
    },
    getBookingAgentName(bookingAgent) {
      const { price, isZh } = this
      let company = null
      if (this.$store.getters.tenantId === price.tenantId) {
        if (!StrUtils.isEmpty(price.sourcePriceUuid)) {
          return this.tenantUtil.getTenantNameById(price.bookingAgent)
        } else {
          company = this.getCompanyByIdSync(bookingAgent)
        }
      } else {
        return this.tenantUtil.getTenantNameById(price.tenantId)
      }
      if (company) {
        return (isZh ? company.chineseName : company.englishName) || company.shortName
      }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/styles/element-variables.scss";
.price-dialog{
  p{
    margin-top:10px;
    margin-bottom:10px;
  }
  &-header {
    display: flex;
    padding: 0 10px;
    .left{
      width: 55%;
      h2 {
        margin-top:0;
        margin-bottom:10px;
        color: $--color-primary-light-1;
        span{
          font-size: 1.5em!important;}
      }
      h3 {
        color: $--color-warning;
        margin-bottom: 5px;
        span{
          font-size: 1.17em!important;
        }
      }
    };
    .right{
      flex: 1;
      display: flex;
      text-align: right;
      .el-row{
        margin-bottom: 5px;
      }
      .el-col {
        font-size: 14px;
        font-weight: bold;
        text-align: right;
        color: $--color-primary-light-1;
      }
      &.green{
        .el-col{
          color: $--color-success;
        }
      }
      &.red{
        .el-col {
          color: $--color-danger;
        }
      }
      p{
        font-size: 12px;;
        color: $--color-primary-light-1;
      }
    };
  }
  &-content{
    height: 400px;
    border-top:1px solid $--border-color-base;
    overflow-y: scroll;
    .description{
      padding:10px;
      font-size: 12px;
      .el-row{
        margin-bottom: 10px;
      }
      .blue {
        color: $--color-primary-light-1;
      }
      .info {
        margin-top: 10px;
        span {
          margin-right: 10px;
        }
      }
    }
  }
}

</style>
